import React from "react";
import { FooterStyles } from "./Styles.js";
import logo from "../assets/logo/AcrossLogoTwo.png";
import { Box, Typography, Link, Container } from "@mui/material";
import { Facebook, LinkedIn, Instagram, X } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Box sx={FooterStyles.footerContainer}>
      <Container
        maxWidth="lg"
        disableGutters
        sx={{ px: { xs: 2, sm: 3, md: 4 } }}
      >
        {/* Top Section (Left) and Three Columns (Right) in a single row */}
        <Box
          sx={{
            display: { xs: "block", md: "flex" },
            flexDirection: "row",
            gap: { xs: 4, md: 6 },
            py: { xs: 4, md: 2 },
            borderBottom: "1px solid rgba(255,255,255,0.1)",
            alignItems: "flex-start",
          }}
        >
          {/* Left: Logo and Company Description */}
          <Box
            sx={{
              flex: { md: "0 0 320px" },
              minWidth: { md: 260, xs: "100%" },
              maxWidth: { md: 320, xs: "100%" },
              display: "flex",
              flexDirection: "column",
              gap: 2,
              mb: { xs: 4, md: 0 },
            }}
          >
            <img
              src={logo}
              alt="Across Assist"
              style={{
                width: "100%",
                maxWidth: "300px",
                height: "auto",
              }}
            />
            {/* <Typography
              variant="body2"
              sx={{
                color: "white",
                fontSize: "0.875rem",
                fontWeight: 500,
                letterSpacing: "0.5px",
              }}
            >
              TRUST | CARE | PROTECT
            </Typography> */}
            <Typography
              variant="body1"
              sx={{
                color: "white",
                fontSize: { xs: "0.875rem", md: "0.9rem" },
                lineHeight: 1.6,
                fontFamily: '"Poppins", sans-serif',
                mt: 1,
              }}
            >
              At Across Assist, we're not just a company; we're innovators,
              reshaping the landscape of assurance industry. Our commitment is
              to redefine what you can expect from assurance products, pushing
              the boundaries of possibility in every industry we touch.
            </Typography>
          </Box>

          {/* Right: Three Columns */}
          <Box
            sx={{
              flex: 1,
              width: "100%",
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                sm: "repeat(2, 1fr)",
                md: "repeat(3, 1fr)",
              },
              gap: { xs: 4, md: 6 },
            }}
          >
            {/* COMPANY Column */}
            <Box>
              <Typography
                variant="h6"
                sx={{
                  color: "white",
                  fontWeight: "bold",
                  textDecoration: "underline",
                  fontSize: "0.875rem",
                  mb: 2,
                  fontFamily: '"Poppins", sans-serif',
                }}
              >
                COMPANY
              </Typography>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                {[
                  { label: "About Us", route: "/about-us" },
                  { label: "Blogs", route: "/blogs" },
                  { label: "Career", route: "/career" },
                  { label: "Privacy Policy", route: "/privacy-policy" },
                  { label: "Terms & Conditions", route: "/terms-conditions" },
                  { label: "Become a Partner", route: "/become-partner" },
                  { label: "FAQs", route: "/faqs" },
                ].map((item, index) => (
                  <Typography key={index}>
                    <RouterLink
                      to={item.route}
                      style={{
                        textDecoration: "none",
                        color: "white",
                        fontSize: "0.875rem",
                        fontFamily: '"Poppins", sans-serif',
                        transition: "color 0.3s ease",
                      }}
                      onMouseEnter={(e) => {
                        const target = e.target as HTMLElement;
                        target.style.color = "#60a5fa";
                      }}
                      onMouseLeave={(e) => {
                        const target = e.target as HTMLElement;
                        target.style.color = "white";
                      }}
                    >
                      {item.label}
                    </RouterLink>
                  </Typography>
                ))}
              </Box>
            </Box>

            {/* PRODUCTS Column */}
            <Box>
              <Typography
                variant="h6"
                sx={{
                  color: "white",
                  fontWeight: "bold",
                  textDecoration: "underline",
                  fontSize: "0.875rem",
                  mb: 2,
                  fontFamily: '"Poppins", sans-serif',
                }}
              >
                PRODUCTS
              </Typography>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                {[
                  { label: "Travel Assistance", route: "/travel-assistance" },
                  {
                    label: "Automotive Assistance",
                    route: "/automotive-assistance",
                  },
                  { label: "Gadget Protection", route: "/gadget-protection" },
                  { label: "Home Assistance", route: "/home-assistance" },
                  { label: "Income Protect", route: "/income-protect" },
                  { label: "Travel And Medical", route: "/travel-medical" },
                  { label: "Cyber Security", route: "/cyber-security" },
                ].map((item, index) => (
                  <Typography key={index}>
                    <RouterLink
                      to={item.route}
                      style={{
                        textDecoration: "none",
                        color: "white",
                        fontSize: "0.875rem",
                        fontFamily: '"Poppins", sans-serif',
                        transition: "color 0.3s ease",
                      }}
                      onMouseEnter={(e) => {
                        const target = e.target as HTMLElement;
                        target.style.color = "#60a5fa";
                      }}
                      onMouseLeave={(e) => {
                        const target = e.target as HTMLElement;
                        target.style.color = "white";
                      }}
                    >
                      {item.label}
                    </RouterLink>
                  </Typography>
                ))}
              </Box>
            </Box>

            {/* CONTACT US Column */}
            <Box>
              <Typography
                variant="h6"
                sx={{
                  color: "white",
                  fontWeight: "bold",
                  textDecoration: "underline",
                  fontSize: "0.875rem",
                  mb: 2,
                  fontFamily: '"Poppins", sans-serif',
                }}
              >
                CONTACT US
              </Typography>

              {/* Email */}
              <Box sx={{ mb: 2 }}>
                <Typography
                  sx={{ color: "white", fontSize: "0.875rem", mb: 1 }}
                >
                  <strong style={{ fontFamily: '"Poppins", sans-serif' }}>
                    Email US:
                  </strong>
                </Typography>
                <Link
                  href="mailto:contact@acrossassist.com"
                  sx={{
                    color: "white",
                    textDecoration: "none",
                    fontSize: "0.875rem",
                    fontFamily: '"Poppins", sans-serif',
                    transition: "color 0.3s ease",
                    "&:hover": { color: "#60a5fa" },
                  }}
                >
                  contact@acrossassist.com
                </Link>
              </Box>

              {/* Address */}
              <Box sx={{ mb: 2 }}>
                <Typography
                  sx={{ color: "white", fontSize: "0.875rem", mb: 1 }}
                >
                  <strong style={{ fontFamily: '"Poppins", sans-serif' }}>
                    Reach Us At:
                  </strong>
                </Typography>
                <Link
                  href="https://www.google.com/maps/search/?api=1&query=1st+floor,+Plot+91,+Sector+44,+Gurugram,+Haryana+122022"
                  target="_blank"
                  sx={{
                    color: "white",
                    textDecoration: "none",
                    fontSize: "0.875rem",
                    fontFamily: '"Poppins", sans-serif',
                    transition: "color 0.3s ease",
                    "&:hover": { color: "#60a5fa" },
                  }}
                >
                  1st floor, Plot 91, Sector 44, Gurugram, Haryana 122022
                </Link>
              </Box>

              {/* Phone */}
              <Box sx={{ mb: 3 }}>
                <Typography
                  sx={{ color: "white", fontSize: "0.875rem", mb: 1 }}
                >
                  <strong style={{ fontFamily: '"Poppins", sans-serif' }}>
                    Call Us:
                  </strong>
                </Typography>
                <Link
                  href="tel:+91-120-450-1401"
                  sx={{
                    color: "white",
                    textDecoration: "none",
                    fontSize: "0.875rem",
                    fontFamily: '"Poppins", sans-serif',
                    transition: "color 0.3s ease",
                    "&:hover": { color: "#60a5fa" },
                  }}
                >
                  +91-120-450-1401 (Direct)
                </Link>
                <br />
                <Link
                  href="tel:+91-120-450-1400"
                  sx={{
                    color: "white",
                    textDecoration: "none",
                    fontSize: "0.875rem",
                    fontFamily: '"Poppins", sans-serif',
                    transition: "color 0.3s ease",
                    "&:hover": { color: "#60a5fa" },
                  }}
                >
                  +91-120-450-1400 (Board Line)
                </Link>
              </Box>
            </Box>
          </Box>
        </Box>

        {/* Bottom Section - Copyright and Scroll to Top */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            py: { xs: 3, md: 1 },
            flexDirection: { xs: "column", sm: "row" },
            gap: { xs: 2, sm: 0 },
          }}
        >
          <Typography
            sx={{
              color: "white",
              fontSize: "0.875rem", 
              fontFamily: '"Poppins", sans-serif',
              textAlign: { xs: "center", sm: "left" },
            }}
          >
            Copyright © 2025 Across Assist. All rights reserved.
          </Typography>
          {/* Social Media */}
          <Box display={"flex"} alignItems={"center"} gap={2}>
            <Typography sx={{ color: "white", fontSize: "0.875rem" }}>
              <span
                style={{
                  fontFamily: '"Poppins", sans-serif',
                  marginTop: "10px",
                }}
              >
                Follow Us:
              </span>
            </Typography>
            <Box sx={{ display: "flex", gap: 2 }}>
              <Link
                href="https://www.facebook.com/AcrossAssistIndia"
                target="_blank"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 40,
                  height: 40,
                  backgroundColor: "black",
                  borderRadius: "4px",
                  transition: "background-color 0.3s ease",
                  "&:hover": { backgroundColor: "#1877f2" },
                }}
              >
                <Facebook sx={{ color: "white", fontSize: 20 }} />
              </Link>
              <Link
                href="https://x.com/AcrossAssist_"
                target="_blank" 
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 40,
                  height: 40,
                  backgroundColor: "black",
                  borderRadius: "4px",
                  transition: "background-color 0.3s ease",
                  "&:hover": { backgroundColor: "#000000" },
                }}
              >
                <X sx={{ color: "white", fontSize: 20 }} />
              </Link>
              <Link
                href="https://www.linkedin.com/company/acrossassist/"
                target="_blank"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 40,
                  height: 40,
                  backgroundColor: "black",
                  borderRadius: "4px",
                  transition: "background-color 0.3s ease",
                  "&:hover": { backgroundColor: "#0077b5" },
                }}
              >
                <LinkedIn sx={{ color: "white", fontSize: 20 }} />
              </Link>
              <Link
                href="https://www.instagram.com/acrossassist/?next=%2F"
                target="_blank"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 40,
                  height: 40,
                  backgroundColor: "black",
                  borderRadius: "4px",
                  transition: "background-color 0.3s ease",
                  "&:hover": { backgroundColor: "#e4405f" },
                }}
              >
                <Instagram sx={{ color: "white", fontSize: 20 }} />
              </Link>
            </Box>
          </Box>

          {/* Scroll to Top Button */}
          {/* <button
                        onClick={scrollToTop}
                        style={{
                            width: 48,
                            height: 48,
                            borderRadius: '50%',
                            backgroundColor: '#3b82f6',
                            border: 'none',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            transition: 'background-color 0.3s ease',
                            boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)'
                        }}
                        onMouseEnter={(e) => {
                            const target = e.target as HTMLButtonElement;
                            target.style.backgroundColor = '#2563eb';
                        }}
                        onMouseLeave={(e) => {
                            const target = e.target as HTMLButtonElement;
                            target.style.backgroundColor = '#3b82f6';
                        }}
                    >
                        <svg
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="white"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <path d="M18 15l-6-6-6 6"/>
                        </svg>
                    </button> */}
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
